(function($) {
  const homepageTextImage = Array.from(
    document.querySelectorAll(
      ".case-study-text-image, .case-study-text-image--right"
    )
  );

  /**
   * @description - Function checks if element is in the viewport and adds appropriate class to it.
   */
  const showImageWhenInViewport = function(item) {
    const show = debounce(item => {
      if (item && isInViewport(item)) {
        item.classList.add("in-viewport");
      }
    }, 30);
    show(item);
  };

  /**
   * Initialize functions on start and on scroll
   */
  window.addEventListener("scroll", function() {
    homepageTextImage.forEach(function(item) {
      showImageWhenInViewport(item);
    });
  });

  homepageTextImage.forEach(function(item) {
    showImageWhenInViewport(item);
  });
})();
